const fmt = require("indian-number-format");

export default function HeaderAccount({ interestAmount, depositInterestAmt }) {
  return (
    <div className="px-5 py-3 border-b-2 border-[var(--hover)] text-[14px] space-y-1 text-[var(--text)]">
      <div className="flex justify-between">
        <span className="font-semibold">Deposit Interest Amount :</span>
        <span className={`font-semibold text-[var(--buymeta)]`}>
          {fmt.format(parseFloat(depositInterestAmt).toFixed(0))}
        </span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Interest Amount :</span>
        <span className={`font-semibold text-[var(--sell)]`}>
          {fmt.format(parseFloat(interestAmount).toFixed(0))}
        </span>
      </div>
    </div>
  );
}
